<template>
    <div class="full_content">
        <center>

            <!-- header start -->
            <div class="full_content_area full" v-if="info.display_header">
                <div class="pane_top_div pane_top_height" ref="header_div">

                    <div class="pane_top_desktop max_width">
                        <div class="left_div">
                            <a :href="'/'+info.lang+'/'">
                                <img :src="info.core_info.logo" align="absmiddle" class="top_logo" />
                            </a>
                        </div>
                        <div class="right_div">

                            <div class="right_top_div">

                                <div class="member_name_tag" v-if="info.member != null">
                                    {{info.member.firstName}}
                                </div>
                                <div class="logout_tag" @click="LogoutBtnClick()" v-if="info.member != null">
                                    {{label['paneTop_text_Logout']}}
                                </div>
                                <div class="logout_tag" @click="LoginBtnClick()" v-if="info.member == null">
                                    {{label['paneTop_text_Login']}}
                                </div>
                                <div class="event_search_tag" @click="openEventTitleFilter()">
                                </div>
                                <div class="lang_tag">
                                    <div class="lang_tag_div"
                                         v-for="(lang, index) in info.langcodes"
                                         :key="index"
                                         @click="setLanguage(lang.code)"
                                         v-if="lang.code != info.lang">
                                        {{ lang.name }}
                                    </div>
                                </div>

                            </div>
                            <div class="right_bottom_div">

                                <div class="right_bottom_tag" v-if="info.member != null" @click="MemberMyOrderClick();">
                                    {{label['paneTop_text_myEvents']}}
                                </div>
                                <div class="right_bottom_tag" v-if="info.member == null" @click="windowOpenPage(label['paneTop_text_join_nf_touch_url']);">
                                    {{label['paneTop_text_join_nf_touch']}}
                                </div>
                                <div class="right_bottom_tag" @click="$router.push(`/` + info.lang + '/page/sl/contactus');">
                                    {{label['footer_text_ContactUs']}}
                                </div>

                            </div>

                        </div>
                    </div>

                    <div class="pane_top_responsive max_width pane_top_height" v-if="info.order_temp_info.order_device == 'web'">
                        <div class="left_div">
                            <a :href="'/'+info.lang+'/'">
                                <img :src="info.core_info.logo" align="absmiddle" class="top_logo" />
                            </a>
                        </div>
                        <div class="right_div">
                            <div class="right_icon event_search_icon" @click="openEventTitleFilter()" />
                            <div class="right_icon more_menu_icon" @click="topShowMoreOpen()" />
                        </div>
                    </div>

                    <div class="pane_top_device max_width pane_top_height" v-if="info.order_temp_info.order_device != 'web'">
                        <div class="left_div">
                            <div class="lang_tag">
                                <div class="lang_tag_div"
                                     v-for="(lang, index) in info.langcodes"
                                     :key="index"
                                     @click="setLanguage(lang.code)"
                                     v-if="lang.code != info.lang">
                                    {{ lang.name }}
                                </div>
                            </div>
                        </div>
                        <div class="right_div">
                            <div class="right_tag member_name_tag" v-if="info.member != null">
                                {{info.member.firstName}}
                            </div>
                            <div class="right_tag my_event" v-if="info.member != null" @click="MemberMyOrderClick();">
                            </div>
                            <div class="right_tag member_login" @click="LoginBtnClick()" v-if="info.member == null">
                                {{label['paneTop_text_Login']}}
                            </div>
                        </div>
                    </div>
                    <!-- pane_top end -->

                </div>
            </div>
            <!-- header end -->

            <!-- main start -->
            <div class="full_content_area full main_content_div" v-if="checkBrowser.checking">
                <div ref="main_div">
                    <transition name="fade" mode="out-in">
                        <router-view class="view"></router-view>
                    </transition>
                </div>
            </div>


            <div class="full_content_area full main_content_div" v-if="!checkBrowser.checking">
                <div class="staticpage" v-if="!checkBrowser.version">
                    <div class="staticpage_area">
                        <div class="staticpage_div">
                            <div class="staticpage_inner_area">
                                <div class="staticpage_content" v-html="label['error_browserVersion_msg']"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="staticpage" v-if="!checkBrowser.resolution">
                    <div class="staticpage_area">
                        <div class="staticpage_div">
                            <div class="staticpage_inner_area">
                                <div class="staticpage_content" v-html="label['error_browserResolution_msg']"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- main end -->

            <!-- footer start -->
            <div class="full_content_area full" v-if="!checkIsFooderHeaderDisplay()">
                <div class="pane_bottom_div" ref="footer_div"></div>
            </div>
            <div class="full_content_area full" v-if="checkIsFooderHeaderDisplay()">
                <div class="pane_bottom_div" ref="footer_div">

                    <div class="pane_bottom max_width">

                        <!--<div class="pane_bottom_row_1">

                            <div class="row_1_tag" @click="$router.push(`/` + info.lang + '/page/sl/contactus');">
                                {{label['footer_text_ContactUs']}}
                            </div>

                        </div>-->
                        <div class="pane_bottom_row_2">

                            <div class="terms_div">
                                <div class="terms_link_tag"
                                     v-for="(page, index) in info.staticPages"
                                     :key="index"
                                     @click="staticPagesRouterTo(page)">
                                    {{ label[page.label] }}
                                </div>
                            </div>

                        </div>
                        <div class="pane_bottom_row_3">
                            <div class="copyright_div" v-html="footerCopyrightAllRightReservedLabelDisplay()"></div>
                        </div>

                    </div>
                    <!-- pane_bottom end -->

                </div>
            </div>
            <!-- footer end -->

            <!-- more menu start -->
            <transition name="slide-fromright">
                <div class="more_menu" v-if="topShowMore" :style="{'height':full_screen_height.height_fix}">
                    <div class="more_menu_main_div">

                        <div class="more_menu_header_div">
                            <div class="logo_div">
                                <img :src="info.core_info.logo" align="absmiddle" class="top_logo" />
                            </div>
                            <div class="close_div">
                                <div class="close_btn" @click="topShowMoreClose()"></div>
                            </div>
                        </div>

                        <div class="more_menu_content_div">

                            <div class="more_menu_upper_content_div">

                                <div class="more_menu_login_div">

                                    <div class="login_row" v-if="info.member != null">
                                        <div class="member_name_tag">
                                            {{info.member.firstName}}
                                        </div>
                                        <div class="logout_tag">
                                            <span @click="LogoutBtnClick();topShowMoreClose();" v-if="info.order_temp_info.order_device == 'web'">{{label['sidemenu_logout_btn_text']}}</span>
                                        </div>
                                    </div>
                                    <div class="login_row" v-if="info.member == null">
                                        <div class="login_tag" @click="LoginBtnClick();topShowMoreClose();">
                                            {{label['sidemenu_login_btn_text']}}
                                        </div>
                                    </div>

                                </div>
                                <div class="more_menu_sidemenu_div">

                                    <div class="sidemenu_tag" v-if="info.member == null" @click="windowOpenPage(label['paneTop_text_join_nf_touch_url'])">
                                        {{label['paneTop_text_join_nf_touch']}}
                                    </div>
                                    <div class="sidemenu_tag" v-if="info.member != null" @click="MemberMyOrderClick()">
                                        {{label['paneTop_text_myEvents']}}
                                    </div>
                                    <div class="sidemenu_tag" @click="$router.push(`/` + info.lang + '/page/sl/contactus');topShowMoreClose();">
                                        {{label['footer_text_ContactUs']}}
                                    </div>

                                </div>

                            </div>

                            <div class="more_menu_lower_content_div">

                                <div class="more_menu_language_div">
                                    <div class="language_header_div">
                                        {{label['sidemenu_language_text']}}
                                    </div>
                                    <div class="language_select_div">
                                        <div class="lang_tag_div"
                                             v-for="(lang, index) in info.langcodes"
                                             :key="index"
                                             @click="setLanguage(lang.code)"
                                             v-if="lang.code != info.lang">
                                            {{ lang.name }}
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </transition>
            <!-- more menu end -->

        </center>


        <!-- event_title_filter start -->
        <transition name="slide-fromright">
            <div class="event_title_filter_div" v-if="eventTitleFilter.openSearch" :style="{'height':full_screen_height.height_fix}">

                <div class="event_title_filter_div_layer">
                    <div class="event_title_filter_inner_div">
                        <div class="event_title_filter_top_div">
                            <div class="fliter_close_icon" @click="closeEventTitleFilter()"></div>
                        </div>
                        <div class="event_title_filter_middle_div">
                            <div class="filter_header">
                                {{label['top_event_title_filter_title']}}
                            </div>
                            <div class="filter_input_div">
                                <div class="filter_box">
                                    <form autocomplete="off" @submit="(e)=>{e.preventDefault();eventTitleFilterSubmit();}">
                                        <div class="search_icon">
                                            <input type="submit" value="" class="top_event_title_filter_submit_btn" />
                                        </div>
                                        <div class="search_input_div">
                                            <input type="text" class="search_input" id="top_event_title_filter_input" v-model="eventTitleFilter.searchTextCurrent" :placeholder="label['top_event_title_filter_placeholder']" maxlength="100" />
                                        </div>
                                        <div class="fliter_close_icon" @click="closeEventTitleFilter()"></div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="event_title_filter_bottom_div">
                            <div class="filter_submit_div" @click="eventTitleFilterSubmit()">
                                {{label['top_event_title_filter_btn']}}
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </transition>
        <!-- event_title_filter end -->



        <modal v-if="info.alertMsg" @close="alertMsgClose()">
            <div slot="body" v-html="info.alertMsg"></div>
            <div slot="footer" class="text-center">
                <button class="confirm_btn nomargin" @click="alertMsgClose()">
                    {{ label["alert_close_btn"] }}
                </button>
            </div>
        </modal>
        <modal v-if="info.alertMsgFunction">
            <div slot="body" v-html="info.alertMsgFunction"></div>
            <div slot="footer" class="text-center">
                <button class="confirm_btn nomargin" @click="alertMsgFunctionClose()">
                    {{ label["alert_close_btn"] }}
                </button>
            </div>
        </modal>

        <modal v-if="info.confirmMsg" @close="info.confirmMsg = ''">
            <div slot="body" class="confirmBody" v-html="info.confirmMsg"></div>
            <div slot="footer" class="text-center">
                <button class="confirm_btn" @click="confirmMsgConfirmClick()">
                    {{ label["alert_confirm_btn"] }}
                </button>

                <button class="close_btn" @click="confirmMsgCancelClick()">
                    {{ label["alert_close_btn"] }}
                </button>
            </div>
        </modal>

        <modal v-if="inCompletePaymentObj.alertOpen" @close="inCompletePaymentObj.alertOpen = false">
            <div slot="body" class="confirmBody" v-html="label['order_retry_text_alert']"></div>
            <div slot="footer" class="text-center">
                <button class="confirm_btn" @click="inCompletePaymentCountDownConfirmClick()">
                    {{ label["order_retry_text_alert_confirm"] }}
                </button>

                <button class="close_btn" @click="inCompletePaymentCountDownRejectClick()">
                    {{ label["order_retry_text_cancel_payment"] }}
                </button>
            </div>
        </modal>

        <div class="loading-dialog d-flex justify-content-center" v-if="info.loading">
            <div class="content align-self-center">
                <span class="ic ic-loading"></span>
            </div>
        </div>

        <modalTop v-if="modalTopMessage != ''" @close="modalTopMessage=''">
            <div slot="body" v-html="modalTopMessage"></div>
            <div slot="footer" class="text-center">
                <button class="confirm_btn nomargin" @click="modalTopMessage=''">
                    {{ label["alert_close_btn"] }}
                </button>
            </div>
        </modalTop>

    </div>
</template>

<script>
    import router from "../router";
    import Modal from "../components/Modal.vue";
    import ModalTop from "../components/ModalTop.vue";

    export default {
        router,
        data: {
            info: {
                browserResolutionChecking: false,
                enableCouponCode: true,

                member: null,
                checkMemberToken: true,
                gt_login_page_url: "",
                gt_login_page_url_app: "",
                gt_clientId: "",
                order_temp_info: {
                    order_device: "web",
                },

                confirmMsg: "",
                confirmMsgConfirmAction: undefined,
                confirmMsgCancelAction: undefined,

                lang: "tc",
                langcodes: [],
                openLangBox: false,
                alertMsg: "",
                alertMsgFunction: "",
                alertMsgFunctionCb: undefined,
                wsHost: "",
                wsUrl: "/api",
                //wsUrl:"https://nanfung-api-temp.st2.web-on.com/api",
                currentDomain: window.location.origin,
                currentFullPath: window.location.origin + window.location.pathname,
                canGoBack: window.location.pathname != "/",
                currentPathName: "/",
                loading: false,
                order: undefined,
                orderResult: undefined,
                serverTimeDiff: 0,

                staticPages: [],
                selectEvent: null,

                core_info: {
                    "logo": "",
                    "social": []
                },

                showEventFilter: false,
                updateEventFilter: 0,

                responsive_width:750,
                display_header: true,
                common_page_init: false,
                common_date_format: "YYYY/MM/DD",
                common_datetime_format: "YYYY/MM/DD HH:mm:ss",
                common_datetime_format2: "YYYY/MM/DD HH:mm",
                api_date_format: "YYYYMMDD",
            },

            goBackAction: undefined,
            exitAction: undefined,
            finishAction: undefined,

            topShowMore: false,

            ga_id: "",
            facebook_pixel_id: "",
            googleTagKey: "",
            addThisId: "",
            checkBrowser: { "checking": true, "version": true, "resolution": true },

            header_div_info: { "height": 0 },

            full_screen_height: {
                    height_fix:"100vh",
                    eventfilter_height_fix:"100vh"
                },

            page_after_login: "/",


            // for event start
            filter_btn_postion_fix: {
                "outer_height": "100%",
                "inner_height": "100%",
                "caculate_sticky_top": "100vh"
            },
            filter_search: {
                "mall": [],
                "category": [],
                "type": [],
                "language": [],
                "date": {
                    "filter_type": "",
                    "date_from": moment().format("YYYY/MM/DD"),
                    "date_to": moment().format("YYYY/MM/DD"),
                    "date_from_display": "",
                    "date_to_display": ""
                },
                "price": -1,
            },
            filter_search_current: {
                "mall": [],
                "category": [],
                "type": [],
                "language": [],
                "date": {
                    "filter_type": "",
                    "date_from": moment().format("YYYY/MM/DD"),
                    "date_to": moment().format("YYYY/MM/DD"),
                    "date_from_display": "",
                    "date_to_display": ""
                },
                "price": -1,
            },
            event_list: {
                "pageno": 1,
                "pagesize": 6,
                "next_page": true,
                "loading": false,
                "list": [],
                "total": -1,
                "last_event_position": 0
            },
            eventTitleFilter: {
                "openSearch": false,
                "searchText": "",
                "searchTextCurrent": "",
            },
            activeScrollLoadEvent: true,
            // for event end

            inCompletePaymentObj: {
                paymentObj: null,
                paymentTimeout: null,
                countdownMin: "00",
                countdownSec: "00",
                countdownDisplay: false,
                alertOpen: false,
                noneInComplete: false
            },

            datePicketLangSetup: {
                "en": {
                    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                    dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                    showMonthAfterYear: false,
                    yearSuffix: ""
                },
                "tc": {
                    monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
                    dayNamesMin: ["日", "一", "二", "三", "四", "五", "六"],
                    showMonthAfterYear: true,
                    yearSuffix: "年"
                },
                "sc": {
                    monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
                    dayNamesMin: ["日", "一", "二", "三", "四", "五", "六"],
                    showMonthAfterYear: true,
                    yearSuffix: "年"
                },
            },

            tempEventDetailsData: null,
            modalTopMessage:""

        },
        computed: {
            label() {
                return this.getLabel();
            },
        },
        components: { Modal, ModalTop },
        created() {
            //console.log("this.$http", this.$http);
            //console.log("process.env", process.env);

            var app = this;
            this.getCurrentLangCode();
            this.getCurrentPathName();
            this.setPageTitle("");
            this.windowResizeEventHandler(null);
            this.GetHeaderHeight();

            this.info.loading = false;

            //get core info json start
            $.get(
                "/files/core.json",
                data => {
                    this.info.core_info = data.core;
                },
                "JSON"
            );
            //get core info json end

            for (var k in allLabel)
                this.info.langcodes.push({ code: k, name: allLabel[k]["lang_name"] });

            /*
            this.setLanguage(
                this.getParameterByName("lang") ||
                window.localStorage.getItem("language") ||
                (navigator.language || navigator.browserLanguage).toLowerCase()
            );
            */
            //this.setLanguage(this.getParameterByName("lang") || window.localStorage.getItem("language") || "tc");

            $(Object.keys(allLabel[this.info.lang]))
                .filter((i, o) => o.indexOf("static_page_title_") == 0)
                .each((i, o) => {
                    //console.log(o);
                    if (o.indexOf("static_page_title_url") >= 0) {
                        if (allLabel[this.info.lang][o + "_link"] != undefined) {
                            this.info.staticPages.push({
                                label: o,
                                url: allLabel[this.info.lang][o + "_link"],
                                target: '_blank'
                            });
                        }
                    }
                    else {
                        var code = o.substr("static_page_title_".length);
                        this.info.staticPages.push({
                            label: o,
                            url: `/` + this.info.lang + "/page/s/" + code,
                            target: '_self'
                        });
                    }
                });

            this.exitAction =
                this.getParameterByName("exitAction") ||
                window.localStorage.getItem("exitAction");

            if (this.exitAction)
                window.localStorage.setItem("exitAction", this.exitAction);

            this.finishAction =
                this.getParameterByName("finishAction") ||
                window.localStorage.getItem("finishAction");

            if (this.finishAction)
                window.localStorage.setItem("finishAction", this.finishAction);

            this.GetConfingJson();

            this.getOrderData();

            this.CreateGATag();



            // load storage data
            this.getInfoMemberData();
            this.getOrderTempInfoData();


            // check default param
            this.CheckInitPageDefaultParam();

            // check browser version and resolution
            this.CheckingBrowser();

            // check the member session timeout
            if (this.info.member != null && this.info.checkMemberToken) {
                this.GetCheckMemberToken(this.info.member.memberToken);
            }

            // check incomplete payment when init
            if (this.$root.info.currentPathName.indexOf("/eventhistory/") < 0 &&
                (this.$root.info.currentPathName != "/confirmation" && this.$root.info.currentPathName != "/order_confirmation")
            ) {
                this.checkMemberContainsInCompletePayment();
            }
        },

        destroyed() {
        },
        mounted() {
            if (this.label['event_init_text_init_message'] != '') {
                this.modalTopMessage = this.label['event_init_text_init_message'];
            }
        },
        watch: {
            '$route': function (to, from) {
                // check incomplete payment when change page
                var toPage = to.path.replace("/" + this.info.lang, "");
                if (toPage == "") {
                    toPage = toPage + "/";
                }
                if (toPage.indexOf("/eventhistory/") < 0 && // that means event history page
                    (toPage != "/confirmation" && toPage != "/order_confirmation")
                ) {
                    this.checkMemberContainsInCompletePayment();
                }
            },
            '$root.info.lang': function (lang) {
                // clear event list when switch lang
                this.clearEventFilter();
            },
        },
        beforeMount() {
            window.addEventListener("resize", this.windowResizeEventHandler);
            window.addEventListener("load", this.onCurrentSessionLoad);
            window.addEventListener("beforeunload", this.onCurrentSessionUnload);
            window.addEventListener('scroll', this.handleScrollEvent);
        },
        beforeDestroy() {
            //console.log("beforeDestroy");
            window.removeEventListener("resize", this.windowResizeEventHandler);
            window.removeEventListener("load", this.onCurrentSessionLoad);
            window.removeEventListener("beforeunload", this.onCurrentSessionUnload);
            window.removeEventListener('scroll', this.handleScrollEvent);

            // remove storage
            this.removeOrderTempInfoData();
        },
        methods: {            
            GetConfingJson() {
                $.ajax({
                    type: "GET",
                    async: false,
                    url: "/files/config.json",
                    contentType: "application/json",
                    dataType: "json",
                    success: (data) => {
                        $.extend(this.info, data.info);
                        this.ga_id = data.ga_id;
                        this.facebook_pixel_id = data.facebook_pixel_id;
                        this.googleTagKey = data.googleTagKey;
                        this.addThisId = data.addThisId;
                    }
                }).catch(function () {
                });
            },
            getWindowHeight() {
                return Math.max(window.innerHeight, $(window).height());
            },
            
            handleScrollEvent() {
                this.SetObjectHeightEvent();
                this.SetPaneTopDataScroll();
            },
            windowResizeEventHandler(e) {
                this.CheckingBrowser();
                this.checkIsHeaderDisplay();
                this.SetObjectHeightEvent();
                this.GetHeaderHeight();
            },
            GetHeaderHeight() {
                var header_div_clientHeight = this.$refs.header_div == undefined ? 0 : this.$refs.header_div.clientHeight;
                this.header_div_info.height = header_div_clientHeight;
            },
            SetObjectHeightEvent() {
                //this.full_screen_height.height_fix = window.innerHeight + "px";
                this.full_screen_height.height_fix = this.getWindowHeight() + "px";
                
                var window_size = window.innerWidth;
                if (window_size > this.info.responsive_width) {
                    this.full_screen_height.eventfilter_height_fix = "auto";
                }
                else {
                    //this.full_screen_height.eventfilter_height_fix = window.innerHeight + "px";
                    this.full_screen_height.eventfilter_height_fix = this.getWindowHeight() + "px";
                }
            },
            SetPaneTopDataScroll() {
                if (this.$refs.header_div != undefined) {
                    var header_div = this.$refs.header_div;
                    if (window.scrollY >= 20) {
                        $(header_div).addClass("scroll");
                    }
                    else {
                        $(header_div).removeClass("scroll");
                    }
                }
            },
            onCurrentSessionLoad(event) {
                window.localStorage.setItem("CurrentSessionActive", true);
            },
            onCurrentSessionUnload(event) {
                window.localStorage.setItem("CurrentSessionActive", false);
            },
            scrollToXY(pos) {
                window.scrollTo(pos.x, pos.y);
            },
            scrollToXYAnimate(pos) {
                $("html, body").animate({
                    scrollTop: pos.y
                }, 200);
            },
            ObjectScrollToObject(scroll_obj, scroll_to_obj) {
                var scroll_to_obj_top = $(scroll_to_obj).offset().top - $(scroll_obj).offset().top;
                $(scroll_obj).animate({ scrollTop: (scroll_obj.scrollTop + scroll_to_obj_top) }, 200);
            },

            writeGoogleMapPath(long, lat) {
                return "https://maps.google.com/maps?ll=" + lat + "," + long + "&z=18&mapclient=embed&q=" + lat + "," + long + "@" + lat + "," + long + "";
            },

            writeDisplayDateFormat(date) {
                var showdate = moment(date);
                /*
                if (this.info.lang == "en") {
                    return showdate.format("DD MMM YYYY");
                }
                else if (this.info.lang == "tc" || this.info.lang == "sc") {
                    return showdate.format("YYYY年M月D日");
                }
                */
                return showdate.format("DD.MM.YYYY");
            },
            writeDisplayDatetimeFormat(date) { 
                return this.writeDisplayDateFormat(date) + " " + moment(date).format("HH:mm:ss");
            },
            writeDisplayDatetimeFormat2(date) {
                //return this.writeDisplayDateFormat(date) + " " + moment(date).format("HH:mm");
                return this.writeDisplayDateFormat(date) + " " + this.sessionTimeFormat(moment(date).format("HH:mm"));
            },
            sessionTimeFormat(time_data) {
                var time_int = parseInt(time_data.replace(":", ""), 10);
                var time_code = "";
                if (time_int >= 1300) {
                    time_int = time_int - 1200;
                    time_code = "pm";
                }
                else {
                    if (time_int < 1200) {
                        time_code = "am";
                    } else {
                        time_code = "pm";
                    }
                }

                var time_string = String(time_int).padStart(4, '0');
                //time_string = time_string.substring(0, 2) + ":" + time_string.substring(2, 4);
                time_string = parseInt(time_string.substring(0, 2), 10) + ":" + time_string.substring(2, 4);
                if (this.info.lang == "en") {
                    return time_string + this.label['common_text_time_' + time_code];
                }
                else {
                    return this.label['common_text_time_' + time_code] + time_string;
                }
            },
            selectSessionSessionRemarkDisplay(selectSession, addBracket) {
                var re = "";
                if (selectSession == null) {
                    re = "";
                }
                else {
                    if (selectSession.sessionRemark == '') {
                        re = "";
                    } else {
                        if (addBracket) {
                            re = re + ' [';
                        }
                        if (this.info.lang == "en") {
                            re = re + selectSession.sessionRemarkEN;
                        }
                        else if (this.info.lang == "sc") {
                            re = re + selectSession.sessionRemarkSC;
                        }
                        else {
                            re = re + selectSession.sessionRemarkTC;
                        }
                        if (addBracket) {
                            re = re + ']';
                        }
                    }
                }

                return re;
            },
            writePriceTagName(tag) {
                //return tag.priceTagName + "" + (tag.priceTagRemarks == "" ? "" : " (" + tag.priceTagRemarks + ")");
                return (tag.priceTagRemarks == "" ? tag.priceTagName : tag.priceTagRemarks);
            },
            windowOpenPage(path) {
                window.open(path);
            },
            selectEventLocationDisplay(eventLocation) {
                var app = this;
                var locationDisplay = "";
                $.each($(eventLocation), function (key, value) {
                    if (app.info.lang == "tc" || app.info.lang == "sc") {
                        locationDisplay = locationDisplay + (locationDisplay == "" ? "" : "、") + value.locationName;
                    }
                    else {
                        locationDisplay = locationDisplay + (locationDisplay == "" ? "" : ", ") + value.locationName;
                    }
                });
                return locationDisplay;
            },

            getItemSubfix() {
                if (this.info.lang == "tc") {
                    return "1";
                }
                else if (this.info.lang == "sc") {
                    return "3";
                }
                else {
                    return "2";
                }
            },
            beforeRouteUpdate() {
                this.info.canGoBack = this.info.currentPathName != "/";
                this.info.openLangBox = false;
                window.scrollTo(0, 0);
            },
            setLanguageSelect(event) {
                this.setLanguage(event.target.value);
            },
            setLanguage(lang) {
                /*
                if (this.topShowMore) {
                    this.topShowMoreClose();
                }

                if (!allLabel[lang])
                    if (lang.indexOf("-") > -1) lang = lang.substring(0, lang.indexOf("-"));
                if (!allLabel[lang])
                    for (var _lang in allLabel) {
                        lang = _lang;
                        break;
                    }
                this.info.lang = lang;
                this.label["footer_text_Copyright_AllRightReserved"] = this.label["footer_text_Copyright_AllRightReserved"].replace("#year#",moment().format("YYYY"));
                if (this.label["page_title"])
                    $("head>title").text(this.label["page_title"]);
                window.localStorage.setItem("language", this.info.lang);
                */
                /*
                var loc = document.location + "";
                var startpos = loc.indexOf("/", 8);
                loc = "/" + lang + "/" + loc.substring(startpos + 4);
                window.open(loc, "_self");
                */
                if (this.topShowMore) {
                    this.topShowMoreClose();
                }
                window.history.replaceState(null, null, ((window.location + "").replace("/" + this.info.lang + "/", "/" + lang + "/")));
                this.info.lang = lang;
                this.setPageTitle("");
            },
            setPageTitle(title) {
				if (title != null && title != "") {
                    $("head>title").text(this.label["page_title"] + " - " + title);
				}
				else {
                    $("head>title").text(this.label["page_title"]);
				}
            },
            getLabel() {
                return allLabel[this.info.lang];
            },
            footerCopyrightAllRightReservedLabelDisplay() {
                return this.label["footer_text_Copyright_AllRightReserved"] = this.label["footer_text_Copyright_AllRightReserved"].replace("#year#", moment().format("YYYY"));
            },
            switchLang() {
                var idx = this.info.langcodes.indexOf(this.info.lang) + 1;
                if (idx >= this.info.langcodes.length) idx = 0;
                this.setLanguage(this.info.langcodes[idx].code);
            },
            setGoBackAction(action) {
                this.goBackAction = action;
            },
            goBack() {
                if (this.goBackAction != undefined && this.goBackAction()) return;
                if (this.exitAction)
                    if (["/shop", "/error"].indexOf(this.info.currentPathName) >= 0) {
                        eval(this.exitAction);
                        return;
                    }
                this.$router.go(-1);
            },
            getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return "";
                return decodeURIComponent(results[2].replace(/\+/g, " "));
            },
            alert(str) {
                // window.alert(this.label[str] || str);
                //this.info.alertMsg = this.label[str] || str;
                this.alertMsg(this.label[str] || str);
                switch (str) {                    
                    case "session.not.found":
                        
                        if (this.$root.finishAction) {
                            eval(this.$root.finishAction);
                            return;
                        } else if (this.$root.exitAction) {
                            eval(this.$root.exitAction);
                            return;
                        }

                        // redirect to home when seesion.not.found
                        this.$router.push(`/` + this.info.lang + `/`);
                        break;

                    case "Object reference not set to an instance of an object.":
                        this.info.alertMsg = this.label["error_serverError"];
                        break;

                    default:
                        break;
                }
            },
            alertMsg(str) {
                this.info.alertMsg = str;
                this.$root.setBodyOverflow(true);
            },
            alertMsgClose() {
                this.info.alertMsg = "";
                this.$root.setBodyOverflow(false);
            },
            alertMsgFunction(str, cb) {
                this.info.alertMsgFunction = str;
                this.info.alertMsgFunctionCb = cb;
                this.$root.setBodyOverflow(true);
            },
            alertMsgFunctionClose() {
                this.info.alertMsgFunction = "";
                if (this.info.alertMsgFunctionCb) {
                    this.info.alertMsgFunctionCb();
                }
                this.$root.setBodyOverflow(false);
            },
            wsPost(url, lang, data, cb) {
                return $.ajax({
                    type: "POST",
                    headers: { lang: this.info.lang },
                    url: url,
                    contentType: "application/json",
                    data: data,
                    dataType: "json",
                    success: (data) => {
                        cb(data);
                    },
                });
            },
            wsPostAsync(url, lang, data, cb) {
                return $.ajax({
                    type: "POST",
                    headers: { lang: this.info.lang },
                    url: url,
                    async: false,
                    contentType: "application/json",
                    data: data,
                    dataType: "json",
                    success: (data) => {
                        cb(data);
                    },
                });
            },
            wsGet(url, lang, cb) {
                return $.ajax({
                    type: "GET",
                    headers: { lang: this.info.lang },
                    url: url,
                    contentType: "application/json",
                    dataType: "json",
                    success: (data) => {
                        cb(data);
                    },
                });
            },
            wsGetAsync(url, lang, cb) {
                return $.ajax({
                    type: "GET",
                    headers: { lang: this.info.lang },
                    url: url,
                    async: false,
                    contentType: "application/json",
                    dataType: "json",
                    success: (data) => {
                        cb(data);
                    },
                });
            },
            staticPagesRouterTo(page) {
                if (page.target == "_self") {
                    this.$router.push(page.url)
                }
                else {
                    window.open(page.url, "_blank");
                }
            },            

            clearAllStoreData() {
                //this.cart.reset();
                this.removeOrderTempInfoData();
                this.removeOrderData();
                //this.removeLLShopListStorage();
                //this.removeCurrentAddressListStorage();
                //this.UpdateCurrentAddressList();

                this.setLocalStorageItem("campaign", "");
                this.setLocalStorageItem("medium", "");
                this.setLocalStorageItem("source", "");
            },
            setBodyOverflow(ishidden) {
                if (ishidden) {
                    //$("html, body").css({ overflow: 'hidden' });
                    $("body").css({ overflow: 'hidden' });
                    //if (window.innerWidth <= this.info.responsive_width) {
                    //if (this.info.order_temp_info.order_device != "web") {
                        //$("html").css({ overflow: 'hidden' });
                    //}
                    //$($("body").find(".full_content")[0]).css({ overflow: 'hidden', 'max-height':'100vh' });
                    //$("html, body").css({ overflow: 'hidden', position: 'fixed' });
                } else {
                    //$("html, body").css({ overflow: 'initial' });
                    $("body").css({ overflow: 'initial' });
                    //if (window.innerWidth <= this.info.responsive_width) {
                    //if (this.info.order_temp_info.order_device != "web") {
                        //$("html").css({ overflow: 'initial' });
                    //}
                    //$($("body").find(".full_content")[0]).css({ overflow: 'initial', 'max-height':'100vh' });
                    //$("html, body").css({ overflow: 'initial', position: 'initial' });
                }
            },

            setOrderData(order_data, submitWaitingList) {
                this.info.order = order_data;
                this.info.order.submitWaitingList = submitWaitingList;
                self.localStorage.setItem("currentOrder", JSON.stringify(this.info.order));
            },
            getOrderData() {
                var currentOrder = self.localStorage.getItem("currentOrder") || "";
                if (currentOrder != "") {
                    this.info.order = JSON.parse(currentOrder);
                }

                //console.log("this.info.order", this.info.order);
            },
            removeOrderData() {
                this.info.order = undefined;
                self.localStorage.removeItem("currentOrder");
            },

            topShowMoreOpen() {
                this.topShowMore = true;
                this.SetObjectHeightEvent();
                this.setBodyOverflow(true);
            },
            topShowMoreClose() {
                this.topShowMore = false;
                this.setBodyOverflow(false);
            },

            getCurrentLangCode() {
                //console.log("this.$route.params.langCode", this.$route.params.langCode);
                if (this.$route.params.langCode == undefined) {
                    if ((navigator.language || navigator.browserLanguage).toLowerCase().startsWith("zh")) {
                        window.location.replace("/tc/" + window.location.search);
                    }
                    else {
                        window.location.replace("/en/" + window.location.search);
                    }
                }
                else {
                    this.info.lang = this.$route.params.langCode;
                    if (this.info.lang != "en" && this.info.lang != "tc" && this.info.lang != "sc") {
                        if ((navigator.language || navigator.browserLanguage).toLowerCase().startsWith("zh")) {
                            window.location.replace("/tc/" + window.location.search);
                        }
                        else {
                            window.location.replace("/en/" + window.location.search);
                        }
                    }
                }
            },
            getCurrentPathName() {                
                this.info.currentPathName = window.location.pathname.replace("/" + this.info.lang, "");
                if (this.info.currentPathName == "") {
                    this.info.currentPathName = this.info.currentPathName + "/";
                }

                this.info.currentFullPath = window.location.origin + window.location.pathname;
                this.info.canGoBack = this.info.currentPathName != "/";
                this.checkIsHeaderDisplay();
            },

            CheckInitPageDefaultParam() {
                var campaign = this.getParameterByName("campaign");
                var medium = this.getParameterByName("medium");
                var source = this.getParameterByName("source");
                this.setLocalStorageItem("campaign", campaign == null ? "" : campaign);
                this.setLocalStorageItem("medium", medium == null ? "" : medium);
                this.setLocalStorageItem("source", source == null ? "" : source);

                var mtoken = this.getParameterByName("data");                
                if (mtoken != null && mtoken != "") {
                    this.sendMemberTokenLogin(mtoken);
                }
                else {
                    mtoken = "";
                }
                var accessToken = this.getParameterByName("accessToken");
                if (accessToken != null && accessToken != "") {

                    if (accessToken == "logout") {
                        this.removeInfoMemberData();
                    }
                    else {
                        this.GetCheckMemberToken(accessToken);
                    }
                    
                }
                else {
                    accessToken = "";
                }

                var default_device = this.getParameterByName("device");
                if (default_device != null && default_device != "") {
                    switch(default_device.toLowerCase()) {
                        case "ios":
                            this.info.order_temp_info.order_device = "ios";
                            break;

                        case "android":
                            this.info.order_temp_info.order_device = "android";
                            break;

                        default:
                            this.info.order_temp_info.order_device = "web";
                            break;
                    }
                }

                // update order info storage (no need to store OrderTempInfo because only contains device data and not prefer refresh page when device not equal web)
                this.setOrderTempInfoData();

                // replace url text
                if ((this.info.currentPathName != "/confirmation" && this.info.currentPathName != "/order_confirmation") && (mtoken != "" || accessToken != "")) {
                    //window.history.replaceState(null, null, this.info.currentPathName);
                    window.history.replaceState(null, null, ("/" + this.info.lang + this.info.currentPathName));
                }
            },

            CheckingBrowser() {
                var bv = GetBrowserVersion();
                //console.log("CheckingBrowser", bv);

                this.checkBrowser.checking = true;
                this.checkBrowser.version = true;
                this.checkBrowser.resolution = true;

                if (bv.browserName == "Safari" && bv.browserMajorVersion < 13) {
                //if (bv.browserName == "Safari" && bv.browserMajorVersion < 11) {
                    this.checkBrowser.checking = false;
                    this.checkBrowser.version = false;
                }
                else if (bv.browserName == "") {
                    this.checkBrowser.checking = false;
                    this.checkBrowser.version = false;
                }

                if (this.checkBrowser.checking && this.info.browserResolutionChecking) {
                    var window_size = window.innerWidth;
                    if ((this.info.order_temp_info.order_device == "web") && (window_size <= this.info.responsive_width)) {
                        this.checkBrowser.checking = false;
                        this.checkBrowser.resolution = false;
                    }
                }
            },

            CreateGATag() {
                if (this.ga_id != "" && typeof WebOnGAObj != 'undefined') {
                    CreateWebOnGA(this.ga_id);
                }
                if (this.facebook_pixel_id != "") {
                    initFacebookPixel(this.facebook_pixel_id);
                }

                if (this.googleTagKey != "") {
                    initGoogleTag(this.googleTagKey);
                }

                if (this.addThisId != "") {
                    initAddThisScript(this.addThisId);
                }
            },
            
            checkIsHeaderDisplay() {
                var window_size = window.innerWidth;
                if (window_size > this.info.responsive_width) {
                    this.info.display_header = true;
                } else {
                    if (this.info.currentPathName == "/" ||
                            this.info.currentPathName == "/shop"
                        ) {
                        //this.info.display_header = true;
                    } else {
                        //this.info.display_header = false;
                    }
                }
            },
            checkIsFooderHeaderDisplay() {
                var window_size = window.innerWidth;
                if (window_size > this.info.responsive_width) {
                    return true;
                } else {
                    if (this.info.order_temp_info.order_device == 'web') {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            },
            goToLoginPage(redirect_path) {
                if (this.info.gt_login_page_url == "")
                    this.GetConfingJson();

                var login_url = this.info.gt_login_page_url + "/" + this.info.lang + "/login";
                login_url = login_url + "?clientId=" + encodeURIComponent(this.info.gt_clientId) + "&redirectPath=" + encodeURIComponent(redirect_path);
                //login_url = login_url + "?redirectPath=" + encodeURIComponent(redirect_path);
                //login_url = login_url + "?redirectPath=" + redirect_path;
                window.open(login_url, "_self");
            },
            goToLoginPageApp(redirect_path) {
                if (this.info.gt_login_page_url_app == "")
                    this.GetConfingJson();

                var login_url = this.info.gt_login_page_url_app;
                login_url = login_url + "?redirecturl=" + encodeURIComponent(redirect_path);
                window.open(login_url, "_self");
            },
            LoginBtnClick() {
                var app = this;
                var gathis = this;
                gathis.$root.NFGA_FillParamCB(
                    function () {

                        app.$root.page_after_login = "/" + app.info.lang + app.info.currentPathName;
                        app.$root.page_after_login += (app.$root.page_after_login.includes('?') ? "&" : "?") + "device=" + app.info.order_temp_info.order_device;

                        if (app.info.order_temp_info.order_device == 'web') {
                            app.goToLoginPage(app.info.currentDomain + app.$root.page_after_login);
                        }
                        else {

                            if (app.$root.info.currentPathName.indexOf("/event/") >= 0) {
                                //app.goToLoginPage(app.info.currentDomain + app.$root.page_after_login);
                                app.$root.page_after_login = "/api/App/WebViewController";
                                app.$root.page_after_login += "?device=" + app.info.order_temp_info.order_device + "&actionType=EventDetails&eventEncode=" + encodeURIComponent(app.tempEventDetailsData.eventEncode);
                                app.goToLoginPageApp(app.info.currentDomain + app.$root.page_after_login);
                            }
                            else {
                                app.$root.page_after_login = "/api/App/WebViewController";
                                app.$root.page_after_login += "?device=" + app.info.order_temp_info.order_device + "&actionType=MemberEventHistory";
                                app.goToLoginPageApp(app.info.currentDomain + app.$root.page_after_login);
                            }

                        }

                    },
                    "NFGA_Register_Login");
            },
            LogoutBtnClick() {
                this.removeInfoMemberData();
            },
            ReloadCurrentPage() {
                window.location.replace(window.location.href + "");
            },

            getCurrentPositionLL(cb, renew) {
                var app = this;
                if (!app.currentPositionLL || renew) {
                    if (
                        navigator.geolocation == undefined
                        //  || !/^https/.test(location.protocol.toLowerCase())
                    ) {
                        this.$root.alert(app.label["shop_device_location_error"]);
                        return;
                    }
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            app.currentPositionLL = {
                                latitude: position.coords.latitude,
                                longitude: position.coords.longitude
                            };

                            self.localStorage.setItem("CurrentPositionLL", JSON.stringify(app.currentPositionLL));
                            if (cb) cb();
                        },
                        function (err) {
                            app.$root.alert(app.label["shop_device_location_error"]);
                        },
                        { enableHighAccuracy: true }
                    );
                }
                else {
                    if (cb) cb();
                }
            },
            getStoreCurrentPositionLL() {
                var p = self.localStorage.getItem("CurrentPositionLL") || "";
                if (p != "") {
                    this.currentPositionLL = JSON.parse(p);
                }
            },
            GoogleMapComputeDistanceBetween(p1, p2) {
              return google.maps.geometry.spherical.computeDistanceBetween(
                new google.maps.LatLng(p1[0], p1[1]),
                new google.maps.LatLng(p2[0], p2[1])
              );
            },

            // for confirm msg start
            setConfirmMsg(msg, confirm_action, close_action) {
                this.info.confirmMsg = msg;
                this.setConfirmMsgConfirmAction(confirm_action);
                this.setConfirmMsgCancelAction(close_action);
                this.$root.setBodyOverflow(true);
            },
            confirmMsgConfirmClick() {
                if (this.confirmMsgConfirmAction != undefined) {
                    this.confirmMsgConfirmAction();
                }
                this.setConfirmMsgConfirmAction();
                this.setConfirmMsgCancelAction();
                this.info.confirmMsg = "";
                this.$root.setBodyOverflow(false);
            },
            confirmMsgCancelClick() {
                if (this.confirmMsgCancelAction != undefined) {
                    this.confirmMsgCancelAction();
                }
                this.setConfirmMsgConfirmAction();
                this.setConfirmMsgCancelAction();
                this.info.confirmMsg = "";
                this.$root.setBodyOverflow(false);
            },
            setConfirmMsgConfirmAction(action) {
                this.confirmMsgConfirmAction = action;
            },
            setConfirmMsgCancelAction(action) {
                this.confirmMsgCancelAction = action;
            },
            // for confirm msg end

            // for order data start
            setOrderTempInfoData() {
                self.localStorage.setItem("OrderTempInfoData", JSON.stringify(this.info.order_temp_info));
            },
            getOrderTempInfoData() {                
                var OrderTempInfoData = self.localStorage.getItem("OrderTempInfoData") || "";
                if (OrderTempInfoData != "") {
                    //this.info.order_temp_info = JSON.parse(OrderTempInfoData);
                    $.extend(this.info.order_temp_info, JSON.parse(OrderTempInfoData));
                }                
            },
            removeOrderTempInfoData() {
                /*
                var temp_order_device = this.info.order_temp_info.order_device + "";
                self.localStorage.removeItem("OrderTempInfoData");
                this.info.order_temp_info.order_device = temp_order_device + "";
                */
            },
            // for order data end

            // for member start
            setInfoMemberData() {
                self.localStorage.setItem("InfoMemberData", JSON.stringify(this.info.member));
            },
            getInfoMemberData() {
                var InfoMemberData = self.localStorage.getItem("InfoMemberData") || "";
                if (InfoMemberData != "") {
                    //$.extend(this.info.member, JSON.parse(InfoMemberData));
                    this.info.member = JSON.parse(InfoMemberData);
                }
                else {
                    this.removeInfoMemberData();
                }
            },
            removeInfoMemberData() {
                self.localStorage.removeItem("InfoMemberData");
                this.info.member = null;
            },
            sendMemberTokenLogin(mtoken) {
                console.log("mtoken", mtoken);
                var app = this;
                this.info.loading = true;
                this.$root
                    .wsPostAsync(
                        app.info.wsUrl + "/Member/MemberLoginTokenChecking",
                        app.lang,
                        JSON.stringify({ "mtoken": mtoken }),
                        (data) => {
                            console.log("MemberLoginTokenChecking", data);
                            
                            if (data.status == 0) {
                                app.info.member = data.member;
                                app.setInfoMemberData();
                                app.info.checkMemberToken = false;
                            } else {
                                //app.$root.alert(data.detail);
                                app.removeInfoMemberData();                                
                            }

                            app.info.loading = false;
                        }
                    )
                    .always(() => {
                        //this.info.loading = false;
                    })
                    .fail(() => {
                        this.$root.alert("Fail!");
                        this.info.loading = false;
                    });
            },
            GetCheckMemberToken(mtoken) {
                console.log("mtoken", mtoken);
                var app = this;
                this.info.loading = true;
                $.ajax({
                    type: "POST",
                    headers: { lang: this.info.lang, memberToken: mtoken },
                    url: app.info.wsUrl + "/Member/GetCheckMemberToken",
                    async: false,
                    contentType: "application/json",
                    data: JSON.stringify({}),
                    dataType: "json",
                    success: (data) => {
                        console.log("GetCheckMemberToken", data);

                        if (data.status == 0) {
                            app.info.member = JSON.parse(JSON.stringify(data.member));
                            app.setInfoMemberData();
                            app.info.checkMemberToken = false;
                        } else {
                            //app.$root.alert(data.detail);
                            app.removeInfoMemberData();
                        }

                        app.info.loading = false;
                    },
                });
            },
            CommonFAQClick() {
                this.$router.push(`/` + this.info.lang + "/page/sl/faq");
                this.topShowMoreClose();
            },
            
            MemberProfileClick() {
                this.$router.push(`/` + this.info.lang + "/member/profile");
                this.topShowMoreClose();
            },
            MemberMyOrderClick() {
                this.$router.push(`/` + this.info.lang + "/member/eventhistory");
                this.topShowMoreClose();
            },
            // for member end

            // event start         
            GetEventList(isSearch) {
                var isFilterSearch = false;

                var app = this;                
                if (!app.event_list.loading && ((app.event_list.total == -1 && app.event_list.next_page) || (app.event_list.total != -1 && app.event_list.total > app.event_list.list.length && app.event_list.next_page))) {
                    app.event_list.loading = true;
                    var filter_text = "";
                    var filter_json = {
                        "pagingNo": app.event_list.pageno,
                        "pagingSize": app.event_list.pagesize,
                        "sortByFeature": true
                    };

                    if (app.$root.filter_search_current.mall.length > 0) {
                        isFilterSearch = true;
                        filter_json.mallCode = app.$root.filter_search_current.mall.slice();
                        filter_text = filter_text + (filter_text == "" ? "?" : "&") + "mall=" + encodeURIComponent(filter_json.mallCode.join());
                    }
                    if (app.$root.filter_search_current.category.length > 0) {
                        isFilterSearch = true;
                        filter_json.categoryCode = app.$root.filter_search_current.category.slice();
                        filter_text = filter_text + (filter_text == "" ? "?" : "&") + "category=" + encodeURIComponent(filter_json.categoryCode.join());
                    }
                    if (app.$root.filter_search_current.type.length > 0) {
                        isFilterSearch = true;
                        filter_json.typeCode = app.$root.filter_search_current.type.slice();
                        filter_text = filter_text + (filter_text == "" ? "?" : "&") + "type=" + encodeURIComponent(filter_json.typeCode.join());
                    }
                    if (app.$root.filter_search_current.language.length > 0) {
                        isFilterSearch = true;
                        filter_json.languageCode = app.$root.filter_search_current.language.slice();
                        filter_text = filter_text + (filter_text == "" ? "?" : "&") + "language=" + encodeURIComponent(filter_json.languageCode.join());
                    }
                    if (app.$root.filter_search_current.price != -1) {
                        isFilterSearch = true;
                        filter_json.priceFrom = 0;
                        filter_json.priceTo = 0;
                        filter_text = filter_text + (filter_text == "" ? "?" : "&") + "price=" + encodeURIComponent(app.$root.filter_search_current.price);
                    }
                    if (app.$root.filter_search.date.filter_type != "") {
                        isFilterSearch = true;
                        filter_json.eventDateFrom = moment(app.$root.filter_search_current.date.date_from).format(this.$root.info.api_date_format);
                        filter_json.eventDateTo = moment(app.$root.filter_search_current.date.date_to).format(this.$root.info.api_date_format);
                        filter_text = filter_text + (filter_text == "" ? "?" : "&") + "dateType=" + encodeURIComponent(app.$root.filter_search.date.filter_type);
                        if (app.$root.filter_search.date.filter_type == "range") {
                            filter_text = filter_text + (filter_text == "" ? "?" : "&") + "dateTypeFrom=" + encodeURIComponent(filter_json.eventDateFrom);
                            filter_text = filter_text + (filter_text == "" ? "?" : "&") + "dateTypeTo=" + encodeURIComponent(filter_json.eventDateTo);
                        }
                    }

                    if (app.eventTitleFilter.searchText != "") {
                        filter_json.eventTitle = app.eventTitleFilter.searchText;
                    }
                    //console.log("filter_json", filter_json);

                    // add search param to url when isSearch
                    if (isSearch) {
                        
                        //if (isFilterSearch)
                            //filter_text = "?eventFilter=" + encodeURIComponent(JSON.stringify(app.$root.filter_search_current));                        
                        if (app.eventTitleFilter.searchText != "") 
                            filter_text = filter_text + (filter_text == "" ? "?" : "&") + "eventTitle=" + encodeURIComponent(app.eventTitleFilter.searchText);
                        
                        window.history.replaceState(null, null, (app.info.currentFullPath + filter_text));
                    }

                    //app.$root.info.loading = true;
                    $.ajax({
                        type: "POST",
                        headers: { lang: app.info.lang, memberToken: (app.info.member == null ? "" : app.info.member.memberToken) },
                        url: app.info.wsUrl + "/Event/GetEventList",
                        async: true,
                        contentType: "application/json",
                        data: JSON.stringify(filter_json),
                        dataType: "json",
                        success: (data) => {
                            console.log("GetEventList", data);
                            if (data.status == 0) {
                                app.event_list.list = app.event_list.list.concat(data.eventList);
                            }

                            window.setTimeout(function () {
                                //app.$root.info.loading = false;
                                app.event_list.pageno = data.pagingNo + 1;
                                app.event_list.total = data.totalEvents;
                                app.event_list.next_page = data.eventList.length > 0 ? true : false;

                                var event_list_tag = $(".event_list_tag:last-child");
                                if (event_list_tag.length > 0) {
                                    app.event_list.last_event_position = $(event_list_tag[0]).offset().top;
                                }
                                //console.log("app.event_list", app.event_list);
                                app.event_list.loading = false;
                                app.SetEventFilterBtnPosition();
                                app.ScrollLoadEvent();
                            }, 100);
                        },
                    });
                }                
            },
            SetEventFilterBtnPosition() {
                //var window_height = $(window).height();
                //var document_height = $(document).height();
                //var bottom_height = $(".pane_bottom_div").outerHeight(true);

                //this.filter_btn_postion_fix.outer_height = (document_height - bottom_height) + "px";
                //this.filter_btn_postion_fix.inner_height = (window.innerHeight) + "px";

                var sticky_icon = $(".open_event_filter_sticky_icon");
                if (sticky_icon.length > 0) {
                    
                    // for sticky
                    var sticky_icon_top = sticky_icon.offset().top;
                    var sticky_icon_height = sticky_icon.outerHeight(true);
                    var pane_bottom_div_top = $(".pane_bottom_div").offset().top;
                    //var caculate_top = window.innerHeight;
                    var caculate_top = this.getWindowHeight();                    
                    if (pane_bottom_div_top >= (sticky_icon_top + sticky_icon_height)) {
                        caculate_top = caculate_top - sticky_icon_height; // for sticky
                    }
                    this.filter_btn_postion_fix.caculate_sticky_top = caculate_top + "px";
                    
                    /*
                    // for fixed
                    var sticky_icon_top = sticky_icon.offset().top;
                    var sticky_icon_height = sticky_icon.outerHeight(true);
                    var pane_bottom_div_top = $(".pane_bottom_div").offset().top;
                    var pane_bottom_div_height = $(".pane_bottom_div").outerHeight(true);
                    //var caculate_top = window.innerHeight - sticky_icon_height;
                    var caculate_top = this.getWindowHeight() - sticky_icon_height;
                    if ((pane_bottom_div_top + pane_bottom_div_height) <= ($(window).scrollTop() + $(window).height())) {
                        caculate_top = caculate_top - pane_bottom_div_height;
                    }
                    this.filter_btn_postion_fix.caculate_sticky_top = caculate_top + "px";
                    */
                }
            },
            ScrollLoadEvent() {
                var app = this;
                if (app.activeScrollLoadEvent) {
                    //console.log($(window).scrollTop() + "," + $(window).height() + "," + app.$root.event_list.last_event_position);
                    if (!app.$root.event_list.loading && app.$root.event_list.last_event_position > 0) {
                        if (($(window).scrollTop() + $(window).height()) >= app.$root.event_list.last_event_position) {
                            app.$root.GetEventList();
                        }
                    }
                }
            },  
            clearEventFilter() {
                var app = this;
                app.$root.filter_search_current = JSON.parse(JSON.stringify(app.filter_search));
                app.$root.event_list.pageno = 1;
                app.$root.event_list.list = [];
                app.$root.event_list.total = -1;
                app.$root.event_list.last_event_position = 0;
                app.event_list.next_page = true;
            },
            openEventTitleFilter() {
                this.eventTitleFilter.openSearch = true;
                this.$root.setBodyOverflow(true);
            },
            closeEventTitleFilter() {
                this.eventTitleFilter.openSearch = false;
                this.eventTitleFilter.searchTextCurrent = this.eventTitleFilter.searchText;
                this.$root.setBodyOverflow(false);
            },
            eventTitleFilterSubmit() {
                this.eventTitleFilter.searchText = this.eventTitleFilter.searchTextCurrent;
                this.closeEventTitleFilter();
                if (this.info.currentPathName == "/") {
                    this.clearEventFilter();
                    this.GetEventList(true);
                } else {
                    this.clearEventFilter();
                    this.$router.push(`/` + this.info.lang + "/");
                }
            },
            eventTitleFilterClear() {
                this.eventTitleFilter.searchText = "";
                this.eventTitleFilter.searchTextCurrent = "";
                this.clearEventFilter();
                this.GetEventList(true);
            },
            goEventDetailsPage(event) {
                var app = this;
                var gathis = this;
                gathis.$root.NFGA_FillParam("NFGA_select_event", "'" + event.eventTitleEN + "'", "'" + event.mall.NFMallID + "'", "'" + event.mall.mallName + "'");

                //app.$router.push(`/` + app.info.lang + `/event/` + encodeURI(event.eventEncode) + `/` + encodeURI(event.eventTitleENNoSpace));
                app.$router.push(`/` + app.info.lang + `/event/` + encodeURI(event.eventEncode) + `/` + encodeURIComponent(event.eventTitleENNoSpace));
            },
            checkEventStatusDisplayText(event) {

                if (event.quotaPerOrder > 0) {

                    if (event.memberIsJoin) {
                        return this.label['event_list_status_text_member_joined'];
                    }
                    else {

                        if (!event.canEnrolment && !event.isPassEvent) {

                            if (event.beforeEnrolmentDate) {
                                //return this.label['event_details_text_enrolment_date_not_start'];
                                return "";
                            }
                            else if (event.afterEnrolmentDate) {
                                return this.label['event_details_text_enrolment_date_is_over'];
                            }
                            else if (!event.beforeEnrolmentDate && !event.afterEnrolmentDate) {
                                return this.label['event_details_text_enrolment_date_is_over'];
                            }

                        }
                        else if (!event.canEnrolment && event.isPassEvent) {

                            if (event.beforePostingDate) {
                                //return this.label['event_details_text_enrolment_date_not_start'];
                                return "";
                            }
                            else if (event.afterPostingDate) {
                                return this.label['event_details_text_enrolment_date_is_over'];
                            }
                            else if (!event.beforePostingDate && !event.afterPostingDate) {
                                return this.label['event_details_text_enrolment_date_is_over'];
                            }

                        }
                        else if (event.canEnrolment && !event.isPassEvent) {

                            if (event.canEnrolment) {

                                if (moment(event.eventEndDate) >= moment(moment().format("YYYYMMDD"))) {

                                    if (event.eventListAllSessionFullComplete) {
                                        if (event.isWaitingList) {
                                            return this.label['event_details_text_join_waiting_list'];
                                        }
                                        else {
                                            return this.label['event_details_text_event_is_full'];
                                        }
                                    }
                                    else {
                                        if (event.eventListAllSessionFull) {
                                            return this.label['event_details_text_event_is_full'];
                                        }
                                        else {
                                            return "";
                                        }
                                    }

                                }
                                else {
                                    return this.label['event_details_text_enrolment_date_is_over'];
                                }

                            }

                        }
                    }

                }
                else {
                    return "";
                }
            },

            CheckEventOrder(eventId, sessionId, priceTag, couponUse, discountCode, paymentType, device, submitWaitingList, reSubmit, reSubmitOrder, cb) {
                    var app = this;
                    app.info.loading = true;

                    var orderCreateJson = {
                        "eventId": eventId,
                        "sessionId": sessionId,
                        "priceTag": priceTag,
                        "couponUse": couponUse,
                        "discountCode": discountCode,
                        "paymentType": paymentType,
                        "device": device,
                        "submitWaitingList": submitWaitingList,
                        "reSubmit": reSubmit,
                        "reSubmitOrder": reSubmitOrder
                    };
                    console.log("orderCreateJson", orderCreateJson);

                    $.ajax({
                        type: "POST",
                        headers: { lang: app.info.lang, memberToken: app.info.member.memberToken },
                        url: app.info.wsUrl + "/Order/CheckEventOrder",
                        contentType: "application/json",
                        data: JSON.stringify(orderCreateJson),
                        dataType: "json",
                        success: (data) => {
                            console.log("CheckEventOrder", data);

                            app.info.loading = false;
                            cb(data);
                        }
                    });
            },
            // event end

            // inComplete payment start
            checkMemberContainsInCompletePayment(currentOrderCode) {
                var app = this;

                if (this.info.member != null) {
                    if (!app.inCompletePaymentObj.noneInComplete) {

                        //this.info.loading = true;
                        $.ajax({
                            type: "POST",
                            headers: { lang: app.info.lang, memberToken: app.info.member.memberToken },
                            url: app.info.wsUrl + "/Member/CheckMemberContainsInCompletePayment",
                            async: true,
                            contentType: "application/json",
                            data: JSON.stringify({}),
                            dataType: "json",
                            success: (data) => {
                                console.log("CheckMemberContainsInCompletePayment", data);

                                //this.info.loading = false;
                                window.clearInterval(app.inCompletePaymentObj.paymentTimeout);

                                if (data.status == 0) {                                    
                                    var paymentObj = data.paymentObj;
                                    this.inCompletePaymentObj.paymentObj = paymentObj;
                                    this.inCompletePaymentObj.countdownMin = (paymentObj.timeout_min_left + "").length < 2 ? ("0" + paymentObj.timeout_min_left) : (paymentObj.timeout_min_left + "");
                                    this.inCompletePaymentObj.countdownSec = (paymentObj.timeout_sec_left + "").length < 2 ? ("0" + paymentObj.timeout_sec_left) : (paymentObj.timeout_sec_left + "");
                                    this.inCompletePaymentCountDownStart();
                                    this.inCompletePaymentObj.alertOpen = (currentOrderCode != paymentObj.paymentCode);
                                    this.inCompletePaymentObj.countdownDisplay = true;
                                } else {

                                    if (data.status == 2) {
                                        //app.inCompletePaymentObj.noneInComplete = true;

                                        // clear all inCompletePaymentObj when no incomplate data
                                        app.inCompletePaymentObj = {
                                            paymentObj: null,
                                            paymentTimeout: null,
                                            countdownMin: "00",
                                            countdownSec: "00",
                                            countdownDisplay: false,
                                            alertOpen: false,
                                            noneInComplete: true
                                        };
                                    }
                                    else if (data.status == 98) {
                                        app.$root.removeInfoMemberData();
                                        app.$root.ReloadCurrentPage();
                                    }
                                    else {
                                        app.checkMemberContainsInCompletePayment(currentOrderCode);
                                    }

                                }

                            },
                        });

                    } // check contains incomplete end
                } // check member end
            },
            inCompletePaymentCountDownConfirmClick() {
                this.inCompletePaymentObj.alertOpen = false;
                //this.inCompletePaymentObj.countdownDisplay = true;
                this.$router.push(`/` + this.info.lang + "/member/eventhistory/" + encodeURI(this.inCompletePaymentObj.paymentObj.paymentCode));
            },
            inCompletePaymentCountDownRejectClick() {
                this.cancelMemberInCompletePayment(JSON.parse(JSON.stringify(this.inCompletePaymentObj.paymentObj)));
                this.inCompletePaymentObj = {
                    paymentObj: null,
                    countdownMin: "00",
                    countdownSec: "00",
                    countdownDisplay: false
                };                
            },
            cancelMemberInCompletePayment(paymentObj, cb) {
                var app = this;
                var gathis = this;
                window.clearInterval(app.inCompletePaymentObj.paymentTimeout);

                this.info.loading = true;
                $.ajax({
                    type: "POST",
                    headers: { lang: app.info.lang, memberToken: app.info.member.memberToken },
                    url: app.info.wsUrl + "/Member/CancelMemberInCompletePayment?payment=" + encodeURIComponent(paymentObj.transactionEncode),
                    async: true,
                    contentType: "application/json",
                    data: JSON.stringify(),
                    dataType: "json",
                    success: (data) => {
                        console.log("CancelMemberInCompletePayment", data);

                        app.inCompletePaymentObj.alertOpen = false;

                        if (cb == null) {
                            if (data.status == 0) {
                                
                                gathis.$root.NFGA_FillParam("NFGA_confirm_cancel", "''", "''", "''", "'" + paymentObj.paymentCode + "'");

                            } else {
                                if (data.status == 6) {
                                    app.$root.alert(app.label['order_retry_text_error_payment_is_complete']);
                                } else if (data.status == 2) {                                    
                                    // not showing any message when 'payment not found'
                                } else if (data.status == 98) {
                                    app.$root.removeInfoMemberData();
                                    app.$root.ReloadCurrentPage();
                                } else {
                                    app.$root.alert(data.detail);
                                }
                            }

                            app.checkMemberContainsInCompletePayment();
                        } else {
                            cb(data);
                        }

                        this.info.loading = false;
                    },
                });
            },
            inCompletePaymentCountDownStart() {
                var app = this;
                //window.clearTimeout(app.inCompletePaymentObj.paymentTimeout);
                //app.inCompletePaymentObj.paymentTimeout = window.setTimeout(function () { app.RefreshInCompletePaymentCountDown(); }, 1000);
                //window.clearInterval(app.inCompletePaymentObj.paymentTimeout); // clear when receive data
                app.inCompletePaymentObj.paymentTimeout = window.setInterval(function () { app.RefreshInCompletePaymentCountDown(); }, 1000);
            },
            RefreshInCompletePaymentCountDown() {
                var app = this;
                if (app.inCompletePaymentObj.paymentObj != null) {
                    var min = parseInt(app.inCompletePaymentObj.countdownMin, 10);
                    var sec = parseInt(app.inCompletePaymentObj.countdownSec, 10);

                    sec = sec - 1;
                    if (sec < 0) {
                        sec = 59;
                        min = min - 1;
                    }
                    if (min < 0) {
                        min = 0;
                    }

                    if (min <= 0 && sec <= 0) {                                                
                        sec = 0;
                        min = 0;
                        window.clearInterval(app.inCompletePaymentObj.paymentTimeout);

                        //app.$root.alert(app.label["inCompletePayment_timeout_alert"]); 
                        //app.inCompletePaymentCountDownRejectClick(); 
                        
                        // not call cancel function only reload the page and wait schedule check order status
                        app.inCompletePaymentObj = {
                            paymentObj: null,
                            countdownMin: "00",
                            countdownSec: "00",
                            countdownDisplay: false
                        };   
                        app.$root.alertMsgFunction(app.label["inCompletePayment_timeout_alert"], function () { app.$root.ReloadCurrentPage(); });
                    }
                    else {
                        //app.inCompletePaymentCountDownStart();
                    }

                    sec = sec + "";
                    if (sec.length < 2) {
                        sec = "0" + sec;
                    }
                    min = min + "";
                    if (min.length < 2) {
                        min = "0" + min;
                    }

                    app.inCompletePaymentObj.countdownMin = min + "";
                    app.inCompletePaymentObj.countdownSec = sec + "";
                }
            },
            // inComplete payment end

            // check event is expired start
            checkEventIsExpired(event) {
                //console.log(event);
                var re = 0;
                if (event != null) {
                    if (!event.isPassEvent) {
                        if (event.canEnrolment) {
                            if (moment(event.eventEndDate) >= moment(moment().format("YYYYMMDD"))) {
                            }
                            else {
                                re = 2;
                            }
                        }
                        else {
                            re = 2;
                        }
                    }
                    else {
                        re = 1;
                    }
                }
                return re;
            },
            // check event is expired end

            GetServerTimeCB(cb) {
                this.$root.wsGet(this.info.wsUrl + "/Other/GetCurrentDatetime", "", cb);
            },
            NFGA_FillParam() {
                //console.log("arguments", arguments);
                var args = arguments;

                var gathis = this;
                var gaEvent = args[0];
                var language = gathis.info.lang;
                var device = gathis.info.order_temp_info.order_device;                
                var entry_time = "";
                var page_title = gathis.info.currentPathName;
                var campaign = gathis.getLocalStorageItem("campaign");
                var medium = gathis.getLocalStorageItem("medium");
                var source = gathis.getLocalStorageItem("source");

                gathis.GetServerTimeCB(function (data) {
                    entry_time = data.datetime;
                    var functionString = gaEvent + "('" + language + "','" + device + "','" + entry_time + "','" + page_title + "','" + campaign + "','" + medium + "','" + source + "'";
                    for (var i = 1; i < args.length; i++) {
                        functionString += ', ' + args[i];
                    }
                    functionString += ");";

                    //console.log("functionString", functionString);
                    eval(functionString);
                });
            },
            NFGA_FillParamCB() {
                //console.log("arguments", arguments);
                var args = arguments;

                var gathis = this;
                var cb = args[0];
                var gaEvent = args[1];
                var language = gathis.info.lang;
                var device = gathis.info.order_temp_info.order_device;
                var entry_time = "";
                var page_title = gathis.info.currentPathName;
                var campaign = gathis.getLocalStorageItem("campaign");
                var medium = gathis.getLocalStorageItem("medium");
                var source = gathis.getLocalStorageItem("source");

                gathis.GetServerTimeCB(function (data) {
                    entry_time = data.datetime;
                    var functionString = gaEvent + "('" + language + "','" + device + "','" + entry_time + "','" + page_title + "','" + campaign + "','" + medium + "','" + source + "'";
                    for (var i = 2; i < args.length; i++) {
                        functionString += ', ' + args[i];
                    }
                    functionString += ");";

                    //console.log("functionString", functionString);
                    eval(functionString);

                    if (cb != null) {
                        window.setTimeout(function () {
                            cb();
                        }, 300);
                    }
                });
            },
            setLocalStorageItem(itemName, itemValue) {
                self.localStorage.setItem(itemName, itemValue);
            },
            getLocalStorageItem(itemName) {
                return self.localStorage.getItem(itemName) || "";               
            },
            setLocalStorageItemArr(itemName, itemValue) {
                var arr = this.getLocalStorageItemArr(itemName);
                if (arr.indexOf(itemValue) < 0) {
                    arr.push(itemValue);
                }
                self.localStorage.setItem(itemName, JSON.stringify(arr));
            },
            getLocalStorageItemArr(itemName) {
                var arr = self.localStorage.getItem(itemName) || "[]";
                return JSON.parse(arr);
            },

        } // end method
    };
</script>
